import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SemCallsV1Component } from '../sem-calls-v1/sem-calls-v1.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import * as _ from 'underscore';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import { SEM_CALLS_SOURCE } from '../../../analytics/constants/analytics.constants';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { CallKeyword } from '../../../analytics-core/interfaces/sem-calls.interface';
import * as numeral from 'numeral';

@Component({
	selector: 'app-sem-calls-r5',
	templateUrl: './sem-calls-r5.component.html',
	styleUrls: ['./sem-calls-r5.component.css']
})
export class SemCallsR5Component extends SemCallsV1Component implements OnInit {
	@ViewChild('graphArea') graphElement: ElementRef;
	public SEM_CALLS_SOURCE = SEM_CALLS_SOURCE;
	private dataLength = 0;
	private leftExtreme = 0;
	private rightExtreme = 0;
	private stepCount = 30;
	private pointsCount = 8;
	public dateRange: string = '';
	dropdownValues = [
		{ id: 1, name: 'All' },
		{ id: 2, name: '1-30 Seconds' },
		{ id: 3, name: '31-60 Seconds' },
		{ id: 4, name: '>60 Seconds' }
	];
	public selectedValues = { id: 1, name: 'All' };
	graphDates = [];
	dropdownDisabled = false;
	public secondaryColor = '#d8d8d8';

	public callsMaxValue;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit() {
		super.ngOnInit();
		this.showLoad = true;
	}

	ngOnChanges(changes) {
		this.showLoad = true;
		if (this.dropdownDisabled == true) {
			this.dropdownDisabled = false;
		}
		if (!_.isEmpty(this.graphData)) {
			this.showLoad = false;
			this.dataLength = this.graphDates.length - 1;
			this.drawGraph();
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
	processResponseData() {
		if (this.keywordsData.length > 0) {
			this.callsMaxValue = this.getPropMax(this.keywordsData, 'calls');
		}
	}

	getPropMax(data, prop) {
		return data.reduce((max, p) => {
			p[prop] = parseFloat(p[prop]);
			return p[prop] > max ? p[prop] : max;
		}, parseFloat(data[0][prop]));
	}

	getPercentage(value) {
		const percentage = (value / this.callsMaxValue) * 100;
		return { width: `${Math.floor(percentage)}%` };
	}

	requestData() {
		this.hasData = true;
		this.showLoad = true;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((responses: any) => {
			if (responses.success) {
				this.graphData = this.mapCallGraphDataToInterface(responses.data.calls_graph_data);
				this.avgDuration = UtilityService.isUndefinedOrNull(responses.data.calls_avg_data[0].avg_duration_in_minutes)
					? 0
					: responses.data.calls_avg_data[0].avg_duration_in_minutes;
				this.callsRecieved = UtilityService.isUndefinedOrNull(responses.data.calls_avg_data[0].call_recieved)
					? 0
					: Number(responses.data.calls_avg_data[0].call_recieved);
				this.callsMissed = UtilityService.isUndefinedOrNull(responses.data.calls_avg_data[0].call_missed)
					? 0
					: Number(responses.data.calls_avg_data[0].call_missed);
				if (this.graphData.length > 0) {
					this.hasData = true;
					setTimeout(() => {
						this.generateGraphData(this.graphData);
						this.drawGraph();
					}, 100);
				} else {
					this.hasData = false;
				}
			} else {
				this.hasData = false;
			}
			if (responses.success) {
				this.keywordsData = this.mapCallKeywordDataToInterface(responses.data.top_keywords_data);
			} else {
				this.hasData = false;
			}
			this.processResponseData();
			this.showLoad = false;
		});
	}

	mapCallKeywordDataToInterface(responseArray: any[]) {
		const keywordsData: CallKeyword[] = [];
		for (const response of responseArray) {
			const keywordObj: CallKeyword = <CallKeyword>{};
			keywordObj.data = parseInt(response.data).toFixed(2);
			keywordObj.source = response.source;
			keywordObj.keyword = response.name;
			keywordsData.push(keywordObj);
		}
		return keywordsData;
	}

	generateGraphData(graphData) {
		if (graphData) {
			this.showLoad = false;
			this.hasData = true;
		} else {
			this.showLoad = true;
			this.hasData = false;
		}
		this.graphObj.graphTitle = '';
		this.graphObj.graphSubTitle = '';
		this.graphObj.xAxisLabel = '';
		this.graphObj.yAxisLabelLeft = '';
		this.graphObj.yAxisLabelRight = '';
		let sortedData = graphData;
		this.graphDates = _.pluck(sortedData, 'date');
		this.graphObj.series = this.buildChartSeriesObj(graphData);
		this.graphObj.categories = this.buildCategoriesObj(graphData);
		//this.graphObj.stepCount = this.calculateStepCount(this.graphObj.categories.length);
		this.graphObj.stepCount = 2;
		this.dataLength = this.graphDates.length - 1;
		this.drawGraph();
	}

	protected buildCategoriesObj(data) {
		const dates = _.pluck(data, 'date');
		return dates.map((x) => {
			x = moment(x, 'MM/DD/YYYY').format('M/D/YY');
			return x;
		});
	}

	dropdownChange(selectedValue) {
		this.selectedValues = selectedValue;
		this.generateGraphData(this.graphData);
	}

	protected buildChartSeriesObj(graphData) {
		const chartSeries: any = [];
		var missed = [];
		var noOfCalls = [];
		if (this.selectedValues.id == 1) {
			missed = _.pluck(graphData, 'missed');
			noOfCalls = _.pluck(graphData, 'noOfCalls');
		} else if (this.selectedValues.id == 2) {
			noOfCalls = _.pluck(graphData, 'oneThirtySecond');
		} else if (this.selectedValues.id == 3) {
			noOfCalls = _.pluck(graphData, 'thirtySixtySecond');
		} else {
			noOfCalls = _.pluck(graphData, 'greaterSixtySecond');
		}
		const totalDataLength = noOfCalls.length;

		const missedObj: any = {};
		const missedSeriesInfo = [
			{
				name: 'Missed',
				data: missed,
				isSeriesData: true
			}
		];

		missedObj.type = 'column';
		missedObj.name = 'Missed';
		missedObj.data = this.buildSeriesWithToolTipInfo(missedSeriesInfo, totalDataLength);
		missedObj.color = '#fff';
		missedObj.fillOpacity = this.chartConfig.seriesConfig[1].fillOpacity;
		missedObj.legendIndex = 2;
		missedObj.maxPointWidth = 10;

		const noOfCallsObj: any = {};
		const noOfCallsSeriesInfo = [
			{
				name: 'Answered',
				data: noOfCalls,
				isSeriesData: true
			}
		];
		noOfCallsObj.type = 'column';
		noOfCallsObj.name = 'Answered';
		noOfCallsObj.color = this.colorPalette.primaryColor;
		noOfCallsObj.data = this.buildSeriesWithToolTipInfo(noOfCallsSeriesInfo, totalDataLength);
		noOfCallsObj.fillOpacity = 0.4;
		noOfCallsObj.legendIndex = 2;
		noOfCallsObj.maxPointWidth = 10;
		chartSeries.push(noOfCallsObj);
		chartSeries.push(missedObj);
		return chartSeries;
	}

	dynamicWidth() {
		(function (H) {
			const each = H.each;
			H.wrap(H['seriesTypes'].column.prototype, 'drawPoints', function (proceed) {
				const series = this;
				if (series.data.length > 0) {
					const width = series.barW > series.options.maxPointWidth ? series.options.maxPointWidth : series.barW;
					each(this.data, function (point) {
						point.shapeArgs.x += (point.shapeArgs.width - width) / 2;
						point.shapeArgs.width = width;
					});
				}
				proceed.call(this);
			});
		})(Highcharts);
	}

	drawGraph() {
		this.dataLength = this.graphDates.length - 1;
		Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					margin: [40, 80, 70, 80],
					height: '250',
					backgroundColor: '#374047'
				},
				title: {
					text: null
				},
				subtitle: {
					text: null
				},
				xAxis: {
					categories: this.graphObj.categories,
					gridLineColor: '#374047',
					lineColor: '#374047',
					offset: 5,
					gridLineWidth: 0,
					tickLength: 0,
					labels: {
						style: {
							color: '#fff',
							fontSize: '9px'
						},
						step: this.graphObj.stepCount,
						formatter: function () {
							return moment(this.value).format('M/D/YY');
						}
					}
				},
				tooltip: {
					shared: false,
					borderColor: this.secondaryColor,
					useHTML: true,
					formatter: function () {
						return (
							'<div style="text-align:center; padding: 2px">' +
							this.x +
							'<br/><b>' +
							this.point['toolTipData'] +
							'</b>' +
							'</div>'
						);
					}
				},
				yAxis: [
					{
						// Primary yAxis
						title: {
							text: 'Calls',
							style: {
								color: '#fff',
								fontSize: '9px'
							}
						},
						labels: {
							style: {
								color: '#fff',
								fontSize: '9px'
							}
						},
						allowDecimals: false,
						gridLineColor: '#374047',
						lineColor: '#374047'
					},
					{
						// Secondary yAxis
						title: {
							text: '',
							style: {
								color: '#fff',
								fontSize: '9px'
							}
						},
						labels: {
							format: '{value}',
							style: {
								color: '#fff',
								fontSize: '9px'
							}
						},
						allowDecimals: false,
						opposite: true,
						gridLineWidth: 0
					}
				],
				credits: {
					enabled: false
				},
				plotOptions: {
					series: {
						events: {
							legendItemClick: (el) => {
								if (el.target['userOptions'].name == 'Answered') {
									if (this.dropdownDisabled == false) {
										this.dropdownDisabled = true;
									} else {
										this.dropdownDisabled = false;
									}
								}
							}
						},
						borderWidth: 0,
						states: {
							inactive: {
								opacity: 1
							}
						}
					},
					column: {
						borderRadius: 5
					}
				},
				legend: {
					layout: 'horizontal',
					align: 'left',
					verticalAlign: 'bottom',
					floating: false,
					x: 40,
					y: 20,
					itemMarginTop: 8,
					itemStyle: {
						fontSize: '8px',
						color: '#fff'
					},
					itemHoverStyle: {
						fontSize: '8px',
						color: '#fff'
					}
				},
				series: this.graphObj.series
			},
			(chart: any) => {
				// on complete
				function noop() {}
				if (this.dataLength > this.stepCount) {
					this.leftExtreme = 0;
					this.rightExtreme = this.stepCount;
					chart['left'] = chart.renderer
						.image('../../../../../assets/creative-assets/left_arrow.svg', 0, 0, 9, 14)
						.on('click', () => {
							if (this.leftExtreme > this.pointsCount) {
								this.leftExtreme -= this.pointsCount;
								this.rightExtreme -= this.pointsCount;
								chart['left'].show();
								chart['right'].show();
							} else {
								this.leftExtreme = 0;
								this.rightExtreme = this.stepCount;
								chart['left'].hide();
								chart['right'].show();
							}
							let startDate = '';
							let endDate = '';
							if (moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
								startDate = moment(this.graphDates[this.leftExtreme + 1], 'MM/DD/YYYY').format('M/D/YY');
							} else {
								startDate = moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('M/D/YY');
							}
							if (moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
								endDate = moment(this.graphDates[this.rightExtreme - 1], 'MM/DD/YYYY').format('M/D/YY');
							} else {
								endDate = moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('M/D/YY');
							}
							this.dateRange = startDate + ' - ' + endDate;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', '0.5%')
						.attr('y', '41%')
						.add();
					chart['right'] = chart.renderer
						.image('../../../../../assets/creative-assets/right_arrow.svg', 0, 0, 9, 14)
						.on('click', () => {
							if (this.dataLength - this.rightExtreme > this.pointsCount) {
								this.leftExtreme += this.pointsCount;
								this.rightExtreme += this.pointsCount;
								chart['left'].show();
								chart['right'].show();
							} else {
								this.leftExtreme = this.dataLength - this.stepCount;
								this.rightExtreme = this.dataLength;
								chart['left'].show();
								chart['right'].hide();
							}
							let startDate = '';
							let endDate = '';
							if (moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
								startDate = moment(this.graphDates[this.leftExtreme + 1], 'MM/DD/YYYY').format('M/D/YY');
							} else {
								startDate = moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('M/D/YY');
							}
							if (moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
								endDate = moment(this.graphDates[this.rightExtreme - 1], 'MM/DD/YYYY').format('M/D/YY');
							} else {
								endDate = moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('M/D/YY');
							}
							this.dateRange = startDate + ' - ' + endDate;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', '98%')
						.attr('y', '41%')
						.add();
					let startDate = '';
					let endDate = '';
					if (moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
						startDate = moment(this.graphDates[this.leftExtreme + 1], 'MM/DD/YYYY').format('M/D/YY');
					} else {
						startDate = moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('M/D/YY');
					}
					if (moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
						endDate = moment(this.graphDates[this.rightExtreme - 1], 'MM/DD/YYYY').format('M/D/YY');
					} else {
						endDate = moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('M/D/YY');
					}
					this.dateRange = startDate + ' - ' + endDate;
					chart.xAxis[0].setExtremes(0, this.rightExtreme);
					chart['left'].hide();
					chart['right'].show();
					chart.redraw();
					chart['right'].translate(-10, 0);
					chart['left'].translate(10, 0);
				} else {
					this.leftExtreme = 0;
					this.rightExtreme = this.dataLength;
					let startDate = '';
					let endDate = '';
					if (moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
						startDate = moment(this.graphDates[this.leftExtreme + 1], 'MM/DD/YYYY').format('M/D/YY');
					} else {
						startDate = moment(this.graphDates[this.leftExtreme], 'MM/DD/YYYY').format('M/D/YY');
					}
					if (moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('MM/DD/YY') === 'Invalid date') {
						endDate = moment(this.graphDates[this.rightExtreme - 1], 'MM/DD/YYYY').format('M/D/YY');
					} else {
						endDate = moment(this.graphDates[this.rightExtreme], 'MM/DD/YYYY').format('M/D/YY');
					}
					this.dateRange = startDate + ' - ' + endDate;
					chart.xAxis[0].setExtremes(0, this.dataLength);
					if (chart['right'] && chart['left']) {
						chart['right'].hide();
						chart['left'].hide();
					}
				}
			}
		);
		this.dynamicWidth();
	}

	downloadCSV() {
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}

	buildSeriesWithToolTipInfo(infoObj: any, totalDataLength: number) {
		const seriesData = [];
		for (let i = 0; i < totalDataLength; i++) {
			const tempObj: any = {};
			let toolTipHTML = '';

			for (const info of infoObj) {
				if (info.isSeriesData) {
					tempObj.y = info.data[i];
				}
				const value = info.data[i];
				toolTipHTML +=
					(this.isFloat(value) ? numeral(value).format('0,0.00') + '%' : numeral(value).format('0,0')) +
					' ' +
					info.name;
			}
			tempObj.toolTipData = toolTipHTML;
			seriesData.push(tempObj);
		}
		return seriesData;
	}

	isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}
}
